/**
 * Created by mykurisu on 2017/9/7.
 */
import React from 'react';
import axios from 'axios';
import {Page, InfiniteScroll} from '../../components'
import {Header} from '../../components/liveroomLecturer'
import {renderMoney, TimeStream} from '../../utils';
import ListNone from '../../images/ban-no-item.png'


class ListItem extends React.Component {

    render() {
        const {content} = this.props;
        return(
            <div className="ban-page-listitem">
                <div className="listitem-left">
                    <div className="listitem-left-icon">
                        <img src={content.account.small_avatar_url} alt=""/>
                    </div>
                    <div className="listitem-left-name">
                        {content.account.nickname}
                        <br/>
                        <div style={{fontSize: '12px', color: '#999'}}>
                            {TimeStream(content.invoice.create_timestamp, 'YMD')}
                        </div>
                    </div>
                </div>
                <div className="listitem-right">
                    <div className="listitem-right-price">
                        ￥ {renderMoney(content.invoice.fee)}
                    </div>
                </div>
            </div>
        )
    }
}

class VipList extends React.Component {
    render() {
        return (
            <div>
                {this.props.vip_list.listeners.map((item) => <ListItem content={item} key={item.invoice.id}/>)}
            </div>
        )
    }
}

class LiveroomVipList extends React.Component {

    constructor() {
        super();
        this.state = {
            vip_list: null,
            loading: false
        }
    }

    componentDidMount() {
        let id = this.props.routeParams.liveroom_id;

        axios.get(`api/liveroom/${id}/vip/listeners`)
            .then(res => {
                if (res.data.code === 0){
                    this.setState({
                        vip_list: res.data.data
                    })
                }
            })
    }

    handleVipListLoadMore() {
        let id = this.props.routeParams.liveroom_id;
        this.setState({
            loading: true
        });
        axios.get(`api/liveroom/${id}/vip/listeners`,{
            params: {
                offset: this.state.vip_list.next_offset
            }
        })
            .then(res => {
                if (res.data.code === 0){
                    let vip = res.data.data;
                    vip.listeners = this.state.vip_list.listeners.concat(vip.listeners);
                    this.setState({
                        vip_list: vip,
                        loading: false
                    })
                }
            })
    }

    render() {
        const {vip_list, loading} = this.state;

        return (
            <Page>
                <div className="liveroom-setting-ban-page">
                    <Header title={'VIP会员名单'}/>

                    {vip_list && vip_list.listeners.length === 0 &&
                    <div className="ban-page-list-none">
                        <img src={ListNone} alt=""/>
                        <p>当前列表暂无数据</p>
                    </div>
                    }

                    {vip_list &&
                    <div>
                        <VipList vip_list={vip_list}/>
                        <InfiniteScroll
                            onTouchBottom={() => this.handleVipListLoadMore()}
                            isStop={loading}
                            distance={300}
                            isKill={!vip_list.has_more}
                        />
                    </div>
                    }
                </div>
            </Page>
        )
    }
}

export default LiveroomVipList


// WEBPACK FOOTER //
// ./src/pages/liveroomLecturer/LiveroomVipList.js